/**
 * Feature-announcement video modal — shape + eligibility.
 *
 * A super-admin sets one system-wide announcement (stored on globalConfigV1/config under
 * `announcement`). Dashboard admins see a one-time modal playing the video. It shows once
 * per `version`; bumping the version (new URL, or an explicit "re-show") brings it back for
 * everyone. A user only ever sees the latest version.
 */

export interface Announcement {
  /** Embed URL (YouTube/Vimeo/Loom/…) rendered by the shared VideoPlayer. */
  videoUrl: string;
  /** Optional modal heading. */
  title?: string;
  /** Master on/off — when false the modal never shows. */
  active: boolean;
  /** Monotonic version; bumped on every URL save and on "re-show to everyone". */
  version: number;
}

/**
 * Whether the one-time modal should show for a user who has dismissed up to
 * `seenVersion`. Guards active + a real URL, and shows only when the current version is
 * newer than what the user has seen.
 */
export const shouldShowAnnouncement = (
  announcement: Announcement | null | undefined,
  seenVersion: number | null | undefined
): boolean =>
  !!announcement &&
  announcement.active === true &&
  !!announcement.videoUrl &&
  announcement.version > (seenVersion ?? 0);
